import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { withTheme } from "styled-components";

const SideBarItem = (props) => {
  const { linkTo, title, iconClass, isSidebarCollapsed, children } = props;
  return (
    <Link to={linkTo} title={title}>
      {children}
      {iconClass && <i className={iconClass} aria-hidden="true" />}
      {!isSidebarCollapsed && <span>{title}</span>}
    </Link>
  );
};

SideBarItem.defaultProps = {
  iconClass: "",
};

SideBarItem.propTypes = {
  linkTo: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  iconClass: PropTypes.string,
  isSidebarCollapsed: PropTypes.bool.isRequired,
};

export default withTheme(SideBarItem);
